import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Stack,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import BasicBreadcrumbs from "../../components/breadcrumb";

import toast from "react-hot-toast";
import FormEmployee from "./formMission1";
import EmployeeList from "./employeeList";
import DetailsMissionForm from "./detailsMissionForm";
import { useLocation, useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { misionData } from "../../data/missionData";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";
import { useApiClient } from "../../context/ApiClientContext";
import ViewDetails from "./viewDetails";
import ActivityListing from "../../components/activityListing";

export const DataContext = React.createContext();

const MissionContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dataList, setDataList] = useState([]);
  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const activities = {
    today: [
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "2 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "open the mission",
        time: "6 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "liked the mission",
        time: "8 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "open the mission",
        time: "12 hours ago",
        image: "https://picsum.photos/60/40?1",
      },
      {
        email: "nurin@gosumgroup.com",
        action: "open the mission",
        time: "12 hours ago",
        image: "https://picsum.photos/60/40?1",
      },
    ],
    thisWeek: [
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to nurin@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to naja@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to tee@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "create this mission",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
    ],
  };


  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  const fetchData = async (page) => {
    try {
      const apiUrl = `${mobileApiUrl}mission/mission-details?missionId=${id}`;
      const response = await api.get(apiUrl);
      // console.log('response',response?.data?.data);

      const missionItem = response?.data?.data || [];
      // console.log('missionItem',missionItem);

      setDataList(missionItem);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  const mission = misionData.find((u) => u.id === Number(id));
  // console.log("id:", mission);

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            // mb: 2,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/mission" underline="hover" color="primary.main">
                  Mission
                </Link>
              }
              second="View" />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Grid container spacing={8} mb={3}>
          {/* <Grid item mt={1} size={{ xs: 12, md: 5 }}>
            <ActivityListing activities={activities} />
          </Grid> */}
          <Grid item size={{ xs: 12 }}>
            <Box display="flex" justifyContent="flex-end" backgroundColor="white" p={2} borderRadius={2} boxShadow={3} mt={2}>

              <ViewDetails id={id} misssionList={dataList} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PrivateLayout>
  );
};

export default MissionContainer;
